var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "emotion-theming", "prop-types", "react", "../../../../breakpoints", "../../css", "../../themes", "../../UI/Icon/ArrowLeft", "../../UI/Icon/ArteVertical", "../../UI/VideoEmbed/VideoEmbed", "./BigBanner.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("emotion-theming"), require("prop-types"), require("react"), require("../../../../breakpoints"), require("../../css"), require("../../themes"), require("../../UI/Icon/ArrowLeft"), require("../../UI/Icon/ArteVertical"), require("../../UI/VideoEmbed/VideoEmbed"), require("./BigBanner.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.emotionTheming, global.propTypes, global.react, global.breakpoints, global.css, global.themes, global.ArrowLeft, global.ArteVertical, global.VideoEmbed, global.BigBanner);
    global.BigBanner = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _emotionTheming, _propTypes, _react, _breakpoints, _css, _themes, _ArrowLeft, _ArteVertical, _VideoEmbed, _BigBanner) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _themes = _interopRequireDefault(_themes);
  _ArrowLeft = _interopRequireDefault(_ArrowLeft);
  _ArteVertical = _interopRequireDefault(_ArteVertical);
  _VideoEmbed = _interopRequireDefault(_VideoEmbed);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var BigBanner = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(BigBanner, _PureComponent);

    var _super = _createSuper(BigBanner);

    function BigBanner() {
      var _this;

      (0, _classCallCheck2.default)(this, BigBanner);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
        showPlayer: false
      });
      return _this;
    }

    (0, _createClass2.default)(BigBanner, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.playerUrl && global.innerWidth >= _breakpoints.nextBreakpoints.LARGE) {
          this.setState({
            showPlayer: true
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            backLink = _this$props.backLink,
            focus = _this$props.focus,
            teaser = _this$props.teaser,
            theme = _this$props.theme,
            playerUrl = _this$props.playerUrl,
            onVideoLoaded = _this$props.onVideoLoaded;
        return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
          theme: _themes.default[theme]
        }, /*#__PURE__*/_react.default.createElement(_BigBanner.StyledBanner, null, backLink && /*#__PURE__*/_react.default.createElement(_BigBanner.StyledLink, {
          focusStyle: _css.focuses[focus].focused,
          href: backLink.url
        }, /*#__PURE__*/_react.default.createElement(_BigBanner.StyledIcon, null, /*#__PURE__*/_react.default.createElement(_ArrowLeft.default, {
          size: {
            default: 'xxsmall',
            medium: 'xsmall'
          }
        })), /*#__PURE__*/_react.default.createElement(_BigBanner.StyledText, {
          focusStyle: _css.focuses[focus].basic
        }, backLink.label)), /*#__PURE__*/_react.default.createElement(_BigBanner.StyledWrapper, null, /*#__PURE__*/_react.default.createElement(_BigBanner.StyledLogo, null, /*#__PURE__*/_react.default.createElement(_ArteVertical.default, {
          size: {
            default: 'small',
            medium: 'medium',
            large: 'large'
          }
        })), /*#__PURE__*/_react.default.createElement(_BigBanner.StyledTeaser, null, /*#__PURE__*/_react.default.createElement(_BigBanner.StyledCaption, null, teaser.title && /*#__PURE__*/_react.default.createElement(_BigBanner.StyledTitle, {
          id: "pageTitle"
        }, teaser.title), teaser.subtitle && /*#__PURE__*/_react.default.createElement(_BigBanner.StyledSubtitle, null, teaser.subtitle)), /*#__PURE__*/_react.default.createElement(_BigBanner.StyledPicture, {
          breakpointFormat: {
            xsmall: 'banner',
            small: 'banner',
            medium: 'banner',
            large: 'banner',
            xlarge: 'banner',
            xxlarge: 'banner'
          },
          images: teaser.images,
          title: teaser.title
        }, playerUrl && this.state.showPlayer && /*#__PURE__*/_react.default.createElement(_BigBanner.StyledPlayer, null, /*#__PURE__*/_react.default.createElement(_VideoEmbed.default, {
          playerUrl: playerUrl,
          onVideoLoaded: onVideoLoaded
        })))))));
      }
    }]);
    return BigBanner;
  }(_react.PureComponent);

  BigBanner.propTypes = {
    backLink: _propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      url: _propTypes.default.string.isRequired
    }),
    focus: _propTypes.default.string,
    onVideoLoaded: _propTypes.default.func,
    playerUrl: _propTypes.default.string,
    teaser: _propTypes.default.shape().isRequired,
    theme: _propTypes.default.string
  };
  BigBanner.defaultProps = {
    focus: 'text',
    onVideoLoaded: function onVideoLoaded() {},
    playerUrl: '',
    theme: 'next'
  };
  var _default = BigBanner;
  _exports.default = _default;
});